import { OfferFormDetail } from "components/other/OfferDetail/OfferFormDetail.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getOfferDetailHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/form/"
)({
    component: OfferFormDetailPage,
    staticData: {
        permissions: [PermissionEnum.OfferIframeView],
        showInSideMenu: false,
        label: "pages.offer.detail.form.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.detail.form.title"),
    }),
});

function OfferFormDetailPage() {
    const userUtils = useUser();
    const { offerId } = Route.useParams();

    return (
        <TenantPage
            headerNavigationItems={getOfferDetailHeaderItems}
            editLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/edit/$offerId/form",
                          params: { offerId: offerId },
                      }
                    : null
            }
        >
            <OfferFormDetail key={offerId} offerId={offerId} />
        </TenantPage>
    );
}
